import React, { useState } from "react";
import {
  Container,
  HeaderSection,
  Title,
  SubText,
  FAQWrapper,
  FAQItem,
  QuestionBox,
  ArrowIcon,
  AnswerBox,
  ContactLink,
} from "../styles/faq.styles";

function FAQ() {
  // 질문 토글창 관리
  const [activeIndices, setActiveIndices] = useState([]);
  const toggleFAQ = (index) => {
    if (activeIndices.includes(index)) {
      setActiveIndices(activeIndices.filter((i) => i !== index));
    } else {
      setActiveIndices([...activeIndices, index]);
    }
  };

  const faqData = [
    {
      question: "비전공자도 지원할 수 있나요?",
      answer:
        "물론입니다! 열정만 있다면 충분히 가능한 수준이기에, 공학 계열뿐만 아니라 인문/상경/예체능 계열 아기사자 분들 모두 성공적으로 수료하고 있습니다. \n(참고로 14기 대표도 인문대 출신이라는 소문이..)",
    },
    {
      question: "막학기/휴학생도 가능한가요?",
      answer:
        "재학생, 휴학생, 졸업유예생 모두 지원 가능합니다. 다만 1년 동안 책임감을 가지고 끝까지 활동하실 수 있는 분이어야 합니다.",
    },
    {
      question: "코딩을 한 번도 해본 적이 없는데 괜찮나요?",
      answer:
        "주 1회 진행되는 스터디를 통해 기초부터 배우기 때문에 노베이스여도 괜찮습니다. 특히 기획/디자인 파트는 직접 코드를 짠다기보다는 전체적인 틀을 설계하는 방법을 배우게 됩니다.\n다만 한정된 시간인 만큼 성장하고자 하는 의지와 투자 시간은 필수입니다!",
    },
    {
      question: "정기 세션(스터디) 일정은 어떻게 되나요?",
      answer:
        "정기 세션은 주 1회 1-2시간 정도 진행됩니다. 구체적인 요일은 부원 모집 완료 후 각 파트별로 의논해 정해질 예정입니다.\n* 스터디는 필참이며 시험기간에는 쉬어갑니다.",
    },
    {
      question: "수료 조건이 어떻게 되나요?",
      answer:
        "1. 중앙 아이디어톤 참여\n2. 중앙 해커톤 참여\n3. 지역 연합 해커톤 참여\n1년간 본사가 주최하는 위 세 행사를 필수로 참여해야 수료증 발급이 가능합니다. 자세한 사항은 커리큘럼 메뉴를 참고 부탁드립니다.",
    },
    {
      question: "활동비(회비)가 있나요?",
      answer:
        "동아리방 비품 구매, OT/MT/해커톤 등 여러 행사의 원활한 운영을 위해 학기당 25,000원의 회비가 존재합니다.\n회비는 모임통장으로 관리되어 부원이라면 언제든지 내역을 확인할 수 있습니다.",
    },
  ];

  return (
    <Container>
      <HeaderSection>
        <Title>FAQ</Title>
        <SubText>
          지원자분들이 자주 묻는 질문을 모았습니다.
          <br />더 궁금한 점이 있으시다면 아래 링크로 언제든 문의해주세요.
        </SubText>
      </HeaderSection>

      {/* 질문 섹션 */}
      <FAQWrapper>
        {faqData.map((item, index) => (
          <FAQItem key={index} $isOpen={activeIndices.includes(index)}>
            <QuestionBox
              onClick={() => toggleFAQ(index)}
              $isOpen={activeIndices.includes(index)}
            >
              <h3>
                <span className="q-mark">Q.</span>
                {item.question}
              </h3>
              <ArrowIcon $isOpen={activeIndices.includes(index)}>▼</ArrowIcon>
            </QuestionBox>

            <AnswerBox $isOpen={activeIndices.includes(index)}>
              <p>{item.answer}</p>
            </AnswerBox>
          </FAQItem>
        ))}
      </FAQWrapper>

      {/* 추가 문의 링크 */}
      <ContactLink href="https://open.kakao.com/o/s7dO7khi" target="_blank">
        더 궁금한 점이 있으신가요? 1:1 오픈채팅방에서 물어보기 ↗
      </ContactLink>
    </Container>
  );
}

export default FAQ;
